import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tooltip,
  message,
} from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import {
  fetchBlosterDropdown,
  resetBlosterList,
  resetCurrentBlosterPage,
} from '../../slices/bolster';
import {
  fetchDiePressDropdown,
  resetCurrentDiePressPage,
  resetDiePressList,
} from '../../slices/die-press';
import {
  fetchVendorDropdown,
  resetCurrentVendorPage,
  resetVendorList,
} from '../../slices/vendor';
import {
  fetchDieProfileDropdown,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';
import {
  fetchDieSizeList,
  fetchDieSizeDropdown,
  resetCurrentDieSizePage,
  resetDieSizeList,
} from './../../slices/die-size';
import { createSecondWeightEntry} from './../../slices/second-weight-entry';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { debounce } from 'lodash';
import moment from 'moment';
import CameraCapture from '../First Weight Entry/CameraCapture';
const { Option } = Select;

function AddSecondWeightEntry() {
  const [form] = Form.useForm();
  
  let navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchDieSize, setSearchDieSize] = useState('');
  const [searchDeveloper, setSearchDeveloper] = useState('');
  const [searchDiePress, setSearchDiePress] = useState('');
  const [searchGroup, setSearchGroup] = useState('');
  const [searchBloster, setSearchBloster] = useState('');
  const dispatch = useDispatch();
  const [runUnderDeviation, setRunUnderDeviation] = useState('under development');
  const [runUnderDeviationReason, setRunUnderDeviationReason] = useState('');
  const {
    list: dieProfileDropdown,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);

  const {
    list: dieSizeList,
    loading: dieSizeLoading,
    currentPage: dieSizeCurrentPage,
    hasMore: dieSizeHasMore,
  } = useSelector(state => state.diesize);
  const {
    list: developerList,
    loading: developerLoading,
    currentPage: developerCurrentPage,
    hasMore: developerHasMore,
  } = useSelector(state => state.vendor);
  const {
    list: blosterList,
    loading: blosterLoading,
    currentPage: blosterCurrentPage,
    hasMore: blosterHasMore,
  } = useSelector(state => state.bloster);
  const {
    list: diePressList,
    loading: diePressLoading,
    currentpage: diePressCurrentPage,
    hasMore: diePressHasMore,
  } = useSelector(state => state.diePress);
  const [isReceivedDateRequired, setIsReceivedDateRequired] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [isCheckboxDisabledActive, setIsCheckboxDisabledActive] = useState(false);
  const [selectedSolidOption, setSelectedSolidOption] = useState(null);
  const [selectedWeightForOption, setSelectedWeightForOption] = useState(null);
  const [selectedWeightAutomaticOption, setSelectedWeightAutomaticOption] = useState(null);
  const [selectedTotalCopy, setSelectedTotalCopy] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const [selectedVehicleNo, setSelectedVehicleNo] = useState(null);
  const [selectedPartyName, setSelectedPartyName] = useState(null);
  const [selectedSerialNo, setSelectedSerialNo] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedPurchaser, setSelectedPurchaser] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [dieType, setDieType] = useState(null);
  const [selectHollowOption, setSelectHollowOption] = useState(null);
  const [selectSemiHollowOption, setSelectSemiHollowOption] = useState(null);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [showInitialLoader, setShowInitialLoader] = useState(false);
  const [showDropdownLoader, setShowDropdownLoader] = useState(false);
  const [forceOpen, setForceOpen] = useState(false);

  const sendingSmsType = [
    { id: 'Sms', name: 'Sms' },
    { id: 'Whatsapp', name: 'Whatsapp' },
    { id: 'None', name: 'None' },
  ];
  const semisendingSmsType = [
    { id: 'Die Plate', name: 'Die Plate' },
    { id: 'Mandril', name: 'Mandril' },
  ];
  const balanceType = [
    { id: 'Debit', name: 'Debit' },
    { id: 'Credit', name: 'Credit' },
    
  ];
  const weightForType = [
    { id: 'weight_for_gross_weight', name: 'Gross Weight' },
    { id: 'weight_for_tare_weight', name: 'Tare Weight' },
    
  ];
  const weightAutomaticType = [
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' },
    
  ];
  const totalCopyList = [
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    
  ];
  const handleSemiHoolowOptionChange = value => {
    setSelectSemiHollowOption(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const getClassNameDieProfile = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedCity?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };


  const getClassNameVehicleType = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedVehicleType?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameVehicleNo = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedVehicleNo?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNamePartyName = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedPartyName?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameSerialNo = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedSerialNo?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameMaterial = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedMaterial?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNamePurchaser = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedPurchaser?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameSeller = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedSeller?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const handleSearchHSemiHollowDie = value => {
    setSelectSemiHollowOption(value);
  };
  const handleSolidOptionChange = value => {
    setSelectedSolidOption(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };
  const handleWeightForOptionChange = value => {
    setSelectedWeightForOption(value);

    
  };
  const handleWeightAutomaticOptionChange = value => {
    setSelectedWeightAutomaticOption(value);

    form.setFieldsValue({
        weight: undefined,
        
      });
  };
  const handleTotalCopyChange = value => {
    setSelectedTotalCopy(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };
  const handleSearchSolidDie = value => {
    setSelectedSolidOption(value);
  };
  const handleSearchWeightFor = value => {
    setSelectedWeightForOption(value);
  };
  const handleSearchWeightAutomatic = value => {
    setSelectedWeightAutomaticOption(value);
  };
  const handleSearchTotalCopy = value => {
    setSelectedTotalCopy(value);
  };
  const handleDeviationChange = e => {
    const value = e.target.value;
    setRunUnderDeviation(value);
    if (value !== 'inactive') {
      setRunUnderDeviationReason('');
    }
    // If "Active" is selected, make received_date required
    if (value === 'active') {
      setIsReceivedDateRequired(true);
    } else {
      setIsReceivedDateRequired(false);
      // If moving away from Active, clear received_date
      if (form.getFieldValue('received_date')) {
        form.setFieldsValue({ received_date: null });
      }
    }
    // If "Active" is selected and no received_date, optionally focus the field (UX improvement)
    if (value === 'active' && !form.getFieldValue('received_date')) {
      // Optionally focus the field
    }
  }

  const handleHoolowOptionChange = value => {
    setSelectHollowOption(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleSearchHollowDie = value => {
    setSelectHollowOption(value);
  };

  const handleReasonChange = e => {
    setRunUnderDeviationReason(e.target.value);
  };

  const handleReceivedDateChange = (date, dateString) => {
    form.setFieldsValue({ received_date: date });
    if (date) {
      setRunUnderDeviation('active');
      setIsReceivedDateRequired(true);
      form.setFieldsValue({ run_under_deviation: 'active', is_active: true });
    } else {
      setRunUnderDeviation('under development');
      setIsReceivedDateRequired(false);
      form.setFieldsValue({ run_under_deviation: 'under development', is_active: false });
    }
  };
  const handleFormChange = changedValues => {
    // Only keep logic for other fields if needed, received_date and run_under_deviation are handled above
    // (No-op for these fields)
  };

  const handleCityChange = (selected, value) => {
    setSelectedCity(value);
 
   
  };
  const handleVehicleTypeChange = (selected, value) => {
    setSelectedVehicleType(value);
 
   
  };
  const handleVehicleNoChange = (selected, value) => {
    setSelectedVehicleNo(value);
 
   
  };
  const handlePartyNameChange = (selected, value) => {
    setSelectedPartyName(value);
 
   
  };
  const handleSerialNoChange = (selected, value) => {
    setSelectedSerialNo(value);
 
   
  };
  const handleMaterialChange = (selected, value) => {
    setSelectedMaterial(value);
 
   
  };
  const handlePurchaserChange = (selected, value) => {
    setSelectedPurchaser(value);
 
   
  };
  const handleSellerChange = (selected, value) => {
    setSelectedSeller(value);
 
   
  };
  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData()); // Reset the list when searching
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: value || '',
      }),
    );
  }, 300);
  const handleSearchCity = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchSerialNo = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchVehicleType = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchPartyName = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchMaterial = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchPurchaser = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchSeller = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchVehicleNo = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const onScrollCity = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const onScrollVehicleNo = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const onScrollSeller = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const onScrollPurchaser = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const onScrollMaterial = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const onScrollPartyName = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const onScrollVehicleType = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const onScrollSerialNo = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };

  const onScrollDiePress = async event => {
    const target = event.target;
    if (
      !diePressLoading &&
      diePressHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDiePressDropdown({ page: diePressCurrentPage, pagesize: 10 }),
      );
    }
  };

  const handleSearchDieSize = value => {
    setSearchDieSize(value);
    if (value) {
      setSearchDieSize(value);
      dispatch(resetDieSizeList());
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDieSize('');
      dispatch(resetDieSizeList());
      dispatch(resetCurrentDieSizePage());
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100, search: value }));
    }
  };
  const handleChangeDieSize = value => {
    setSearchDieSize(value);
  };

  const handleSearchDeveloper = value => {
    setSearchDeveloper(value);
    if (value) {
      setSearchDeveloper(value);
      dispatch(resetVendorList());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDeveloper('');
      dispatch(resetVendorList());
      dispatch(resetCurrentVendorPage());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeDeveloper = value => {
    setSearchDeveloper(value);
  };

  const handleSearchBloster = value => {
    setSearchBloster(value);
    if (value) {
      setSearchBloster(value);
      dispatch(resetBlosterList());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchBloster('');
      dispatch(resetBlosterList());
      dispatch(resetCurrentBlosterPage());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeBloster = value => {
    setSearchBloster(value);
  };

  const onScrollDieSize = async event => {
    const target = event.target;
    if (
      !dieSizeLoading &&
      dieSizeHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDieSizeDropdown({ page: dieSizeCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollDeveloper = async event => {
    const target = event.target;
    if (
      !developerLoading &&
      developerHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchVendorDropdown({ page: developerCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollBloster = async event => {
    const target = event.target;
    if (
      !blosterLoading &&
      blosterHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchBlosterDropdown({ page: blosterCurrentPage, pagesize: 10 }));
    }
  };
  const handleSearchDiePress = value => {
    setSearchDiePress(value);
    if (value) {
      setSearchDiePress(value);
      dispatch(resetDiePressList());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10, search: value }));
    } else {
      setSearchDiePress('');
      dispatch(resetDiePressList());
      dispatch(resetCurrentDiePressPage());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeDiePress = value => {
    setSearchDiePress(value);
  };

  useEffect(() => {
    dispatch(resetDieProfileList());
    dispatch(resetDieSizeList());
    dispatch(resetDiePressList());
    dispatch(resetVendorList());
    dispatch(resetBlosterList());
    dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 1000 }));
    // dispatch(fetchDieSizeList({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100 }));
    dispatch(fetchVendorDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchBlosterDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchDiePressDropdown({ page: 1, pagesize: 1000 }));
  }, [dieType]);

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedValues = {
      ...values,

 
    };
    values = formattedValues;
    // values.deleted = 0;
    dispatch(createSecondWeightEntry({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Second Weight Entry Created Successfully!');
          navigate('/second-weight-entry-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const handleFieldChange = () => {
    const rackNo = form.getFieldValue('rac_no') || '';
    const rowNo = form.getFieldValue('row_no') || '';
    const columnNo = form.getFieldValue('column_no') || '';

    const dieLocation = `${rackNo} / ${rowNo} / ${columnNo}`;

    form.setFieldsValue({ die_location: dieLocation });
  };
  return (
    <>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Add Second Weight Entry (Last 2 Days)</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/second-weight-entry-list">Second Weight Entry List</Link> },
                  { title: 'Add Second Weight Entry' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          onValuesChange={handleFormChange}
          form={form}
          initialValues={{
            is_active: true,
         
          }}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <div className="formsection">
            <Row gutter={16}>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="weight_for"
                    label="Weight For"
                    rules={[
                      {
                        required: true,
                        message: 'Please select weight for',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Weight For"
                      onChange={handleWeightForOptionChange}
                      onSearch={handleSearchWeightFor}
                      showSearch={true}
                      value={selectedWeightForOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          weightForType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="weight_automatic"
                    label="Weight Automatic"
                    rules={[
                      {
                        required: true,
                        message: 'Please select weight automatic or not',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Weight Automatic"
                      onChange={handleWeightAutomaticOptionChange}
                      onSearch={handleSearchWeightAutomatic}
                      showSearch={true}
                      value={selectedWeightAutomaticOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                            weightAutomaticType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                {selectedWeightAutomaticOption === 'No' &&
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Enter Weight"
                  name="weight"
                  rules={[
                    { required: true, message: 'Please enter weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Weight" maxLength={15} />
                </Form.Item>
              </Col>}
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Gross Weight"
                  name="gross_weight"
                  rules={[
                    { required: true, message: 'Please enter gross weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Gross Weight" maxLength={15} />
                </Form.Item>
              </Col>
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Tare Weight"
                  name="tare_weight"
                  rules={[
                    { required: true, message: 'Please enter tare weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Tare Weight" maxLength={15} />
                </Form.Item>
              </Col>
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Net Weight"
                  name="net_weight"
                  rules={[
                    { required: true, message: 'Please enter net weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Net Weight" maxLength={15} />
                </Form.Item>
              </Col>
            
                {/* <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Serial No."
                  name="serial_no"
                  rules={[
                    { required: true, message: 'Please enter serial_no' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Serial No." maxLength={15} />
                </Form.Item>
              </Col> */}
         <Col xs={12} sm={6} xl={4}>
  <Form.Item
    name="start_date"
    label="Date & Time First"
    rules={[
      { required: true, message: 'Please select date and time' },
    ]}
  >
    <DatePicker
      showTime={{ use12Hours: true, format: 'hh:mm A' }} 
      format="DD-MM-YYYY hh:mm A"                        
      style={{ width: '100%' }}
    />
  </Form.Item>
</Col>

<Col xs={12} sm={6} xl={4}>
  <Form.Item
    name="end_date"
    label="Date & Time Second"
    rules={[
      { required: true, message: 'Please select date and time' },
    ]}
  >
    <DatePicker
      showTime={{ use12Hours: true, format: 'hh:mm A' }} 
      format="DD-MM-YYYY hh:mm A"                        
      style={{ width: '100%' }}
    />
  </Form.Item>
</Col>

                 <Col xs={12} sm={8} xl={6} xxl={3}>
            
            <Form.Item
              label="Mound"
              name="Mound"
              rules={[
                { required: true, message: 'Please enter mound' },
              ]}
            >
              <Input placeholder="Enter Mound"  />
            </Form.Item>
          </Col>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Serial No."
                name="serial_no"
                rules={[
                  { required: true, message: 'Please select a serial no.' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Serial No."
                  style={{ width: '100%' }}
                  onChange={handleSerialNoChange}
                  open={forceOpen || undefined}
                  labelInValue={true}
                  loading={dieProfileLoading}
                  onPopupScroll={onScrollSerialNo}
                  // onDropdownVisibleChange={(open) => {
                  //   if (open) {
                  //     setForceOpen(true);
                  //     setShowDropdownLoader(true);
                  //     setTimeout(() => {
                  //       setShowDropdownLoader(false);
                  //       setForceOpen(false);
                  //     }, 2000);
                  //   }
                  // }}
                  value={searchGroup ? { value: searchGroup } : undefined}
                  notFoundContent={null} 
                  showSearch={true}
                  onSearch={handleSearchSerialNo}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameSerialNo()}
                  dropdownRender={menu => (
                    <>
                      {showDropdownLoader ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {showDropdownLoader
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="total_copy"
                    label="Total Copy"
                    rules={[
                      {
                        required: true,
                        message: 'Please select total copy',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Total Copy"
                      onChange={handleTotalCopyChange}
                      onSearch={handleSearchTotalCopy}
                      showSearch={true}
                      value={selectedTotalCopy}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                            totalCopyList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
            <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Vehicle No."
                name="vehicle_no"
                rules={[
                  { required: true, message: 'Please select a vehicle no.' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Vehicle No."
                  style={{ width: '100%' }}
                  onChange={handleVehicleNoChange}
                  open={forceOpen || undefined}
                  labelInValue={true}
                  loading={dieProfileLoading}
                  onPopupScroll={onScrollVehicleNo}
                  // onDropdownVisibleChange={(open) => {
                  //   if (open) {
                  //     setForceOpen(true);
                  //     setShowDropdownLoader(true);
                  //     setTimeout(() => {
                  //       setShowDropdownLoader(false);
                  //       setForceOpen(false);
                  //     }, 2000);
                  //   }
                  // }}
                  value={searchGroup ? { value: searchGroup } : undefined}
                  notFoundContent={null} 
                  showSearch={true}
                  onSearch={handleSearchVehicleNo}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameVehicleNo()}
                  dropdownRender={menu => (
                    <>
                      {showDropdownLoader ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {showDropdownLoader
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
          <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Vehicle type"
                name="vehicle_type"
                rules={[
                  { required: true, message: 'Please select a vehicle type' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Vehicle Type"
                  style={{ width: '100%' }}
                  onChange={handleVehicleTypeChange}
                  open={forceOpen || undefined}
                  labelInValue={true}
                  loading={dieProfileLoading}
                  onPopupScroll={onScrollVehicleType}
                  // onDropdownVisibleChange={(open) => {
                  //   if (open) {
                  //     setForceOpen(true);
                  //     setShowDropdownLoader(true);
                  //     setTimeout(() => {
                  //       setShowDropdownLoader(false);
                  //       setForceOpen(false);
                  //     }, 2000);
                  //   }
                  // }}
                  value={searchGroup ? { value: searchGroup } : undefined}
                  notFoundContent={null} 
                  showSearch={true}
                  onSearch={handleSearchVehicleType}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameVehicleType()}
                  dropdownRender={menu => (
                    <>
                      {showDropdownLoader ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {showDropdownLoader
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
          <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Party Name"
                name="party_name"
                rules={[
                  { required: true, message: 'Please select a party name' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Party Name"
                  style={{ width: '100%' }}
                  onChange={handlePartyNameChange}
                  open={forceOpen || undefined}
                  labelInValue={true}
                  loading={dieProfileLoading}
                  onPopupScroll={onScrollPartyName}
                  // onDropdownVisibleChange={(open) => {
                  //   if (open) {
                  //     setForceOpen(true);
                  //     setShowDropdownLoader(true);
                  //     setTimeout(() => {
                  //       setShowDropdownLoader(false);
                  //       setForceOpen(false);
                  //     }, 2000);
                  //   }
                  // }}
                  value={searchGroup ? { value: searchGroup } : undefined}
                  notFoundContent={null} 
                  showSearch={true}
                  onSearch={handleSearchPartyName}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNamePartyName()}
                  dropdownRender={menu => (
                    <>
                      {showDropdownLoader ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {showDropdownLoader
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
            
            <Form.Item
              label="Cash Party Name"
              name="cash_party_name"
              rules={[
                { required: true, message: 'Please enter cash party name' },
              ]}
            >
              <Input placeholder="Enter Cash Party Name"  />
            </Form.Item>
          </Col>
          <Col xs={12} sm={8} xl={6} xxl={4}>
              <Form.Item
                    label="Party Mobile No."
                    name="party_mobile_no"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your party mobile number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter party mobile number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Material"
                name="material"
                rules={[
                  { required: true, message: 'Please select a material' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Material"
                  style={{ width: '100%' }}
                  onChange={handleMaterialChange}
                  open={forceOpen || undefined}
                  labelInValue={true}
                  loading={dieProfileLoading}
                  onPopupScroll={onScrollMaterial}
                  // onDropdownVisibleChange={(open) => {
                  //   if (open) {
                  //     setForceOpen(true);
                  //     setShowDropdownLoader(true);
                  //     setTimeout(() => {
                  //       setShowDropdownLoader(false);
                  //       setForceOpen(false);
                  //     }, 2000);
                  //   }
                  // }}
                  value={searchGroup ? { value: searchGroup } : undefined}
                  notFoundContent={null} 
                  showSearch={true}
                  onSearch={handleSearchMaterial}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameMaterial()}
                  dropdownRender={menu => (
                    <>
                      {showDropdownLoader ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {showDropdownLoader
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Purchaser"
                name="purchaser"
                rules={[
                  { required: true, message: 'Please select a purchaser' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Purchaser"
                  style={{ width: '100%' }}
                  onChange={handlePurchaserChange}
                  open={forceOpen || undefined}
                  labelInValue={true}
                  loading={dieProfileLoading}
                  onPopupScroll={onScrollPurchaser}
                  // onDropdownVisibleChange={(open) => {
                  //   if (open) {
                  //     setForceOpen(true);
                  //     setShowDropdownLoader(true);
                  //     setTimeout(() => {
                  //       setShowDropdownLoader(false);
                  //       setForceOpen(false);
                  //     }, 2000);
                  //   }
                  // }}
                  value={searchGroup ? { value: searchGroup } : undefined}
                  notFoundContent={null} 
                  showSearch={true}
                  onSearch={handleSearchPurchaser}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNamePurchaser()}
                  dropdownRender={menu => (
                    <>
                      {showDropdownLoader ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {showDropdownLoader
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Seller"
                name="seller"
                rules={[
                  { required: true, message: 'Please select a seller' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Seller"
                  style={{ width: '100%' }}
                  onChange={handleSellerChange}
                  open={forceOpen || undefined}
                  labelInValue={true}
                  loading={dieProfileLoading}
                  onPopupScroll={onScrollSeller}
                  // onDropdownVisibleChange={(open) => {
                  //   if (open) {
                  //     setForceOpen(true);
                  //     setShowDropdownLoader(true);
                  //     setTimeout(() => {
                  //       setShowDropdownLoader(false);
                  //       setForceOpen(false);
                  //     }, 2000);
                  //   }
                  // }}
                  value={searchGroup ? { value: searchGroup } : undefined}
                  notFoundContent={null} 
                  showSearch={true}
                  onSearch={handleSearchSeller}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameSeller()}
                  dropdownRender={menu => (
                    <>
                      {showDropdownLoader ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {showDropdownLoader
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        dieProfileDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.die_number}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>

                  

           
            <Col xs={24} sm={12} xl={8}>
            <Form.Item
              label="Capture Image"
              name="captured_image"
              valuePropName="image"
            >
              <CameraCapture
                onCapture={(imageSrc) => form.setFieldValue("captured_image", imageSrc)}
              />
            </Form.Item>
          </Col>

            </Row>
          </div>
       
          <div className="flex justify-end">
            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                icon={<PlusOutlined />}
              >
                Add Second Weight Entry
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
}

export default AddSecondWeightEntry;
